export enum UserStatus {
  UNDEFINED = -1,
  ACTIVE = -2,
  INACTIVE = -3,
  PENDING = -4,
}
